import { render } from "./BarSeparator.vue?vue&type=template&id=e605c7a0"
const script = {}

import exportComponent from "/Users/romain/Developer/vue-document-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__